import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Persona from './views/Persona.vue';
import Shop from './views/Shop.vue';
import Shoppingcart from './views/Shoppingcart.vue';
import Checkout from './views/Checkout.vue';
import Confirmation from './views/Confirmation.vue';
import Horoskop from './views/Horoskop.vue';
import Datenschutz from './views/Datenschutz.vue';
import Agb from './views/Agb.vue';
import Impressum from './views/Impressum.vue';
import Kontakt from './views/Kontakt.vue';
import Hilfe from './views/Hilfe.vue';
import LogView from './views/LogView.vue';
import PageNotFound from './views/PageNotFound.vue';

Vue.use(Router);

export default new Router({
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    base: process.env.ROUTER_BASE,
    mode: 'history',
    routes: [{
        path: '/',
        name: 'home',
        component: Home
    }, {
        path: '/persona',
        name: 'persona',
        component: Persona
    }, {
        path: '/shop',
        name: 'shop',
        component: Shop
    }, {
        path: '/shoppingcart',
        name: 'shoppingcart',
        component: Shoppingcart
    }, {
        path: '/checkout',
        name: 'checkout',
        component: Checkout
    }, {
        path: '/confirmation',
        name: 'confirmation',
        component: Confirmation
    }, {
        path: '/datenschutz',
        name: 'datenschutz',
        component: Datenschutz
    }, {
        path: '/horoskop',
        name: 'horoskop',
        component: Horoskop
    }, {
        path: '/agb',
        name: 'agb',
        component: Agb
    }, {
        path: '/impressum',
        name: 'impressum',
        component: Impressum
    }, {
        path: '/kontakt',
        name: 'kontakt',
        component: Kontakt
    }, {
        path: '/hilfe',
        name: 'hilfe',
        component: Hilfe
    }, {
        path: '/logview',
        name: 'logview',
        component: LogView
    }, {
        path: '*',
        name: 'pagenotfound',
        component: PageNotFound
    }]
});
